<template>
<b-nav v-if="showNav">
    <b-nav-item-dropdown
        id="my-nav-dropdown"
        toggle-class="nav-link-custom">
      <template slot="button-content">
        <i class="fa mr-2 fa-rss text-yellow" font-scale="1"></i>
        <span>OTA</span>
      </template>
      <b-dropdown-item to="/ota/inventory">
        <i class="fa fa-folder-open text-green" font-scale="1"></i>
        Inventory
      </b-dropdown-item>
      <b-dropdown-item to="/ota/profile/:id">
        <i class="fa fa-info text-yellow" font-scale="1"></i>
        Records
      </b-dropdown-item>
      <b-dropdown-item to="/ota/activate/:id" v-if="navPermissions['activate'].enable">
        <i class="fa fa-broadcast-tower text-blue" font-scale="1"></i>
        Activate
      </b-dropdown-item>
      <b-dropdown-item
          v-if="isPortalAdminStatus"
          to="/ota/import">
        <i class="fa fa-upload text-red" font-scale="1"></i>
        Import
        &nbsp; <i class="fa fa-lock text-gray size-32"></i>
      </b-dropdown-item>
      <b-dropdown-item
          v-if="isPortalAdminStatus"
          to="/ota/carrier_admin">
        <i class="fa fa-wrench text-indigo" font-scale="1"></i>
        Carriers
        &nbsp; <i class="fa fa-lock text-gray size-32"></i>
      </b-dropdown-item>
      <b-dropdown-item
          v-if="isPortalAdminStatus"
          to="/ota/user_admin">
        <i class="fa fa-user text-cyan" font-scale="1"></i>
        Users
        &nbsp; <i class="fa fa-lock text-gray size-32"></i>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import initService from '../../../common/api-services/init-service';

export default {
  name: 'top-ota-group',
  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      showNav: false,
      navPermissions: {
        "inventory": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        },
        "profile": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        },
        "activate": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "Administrator"]
        },
        "simtool": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "Administrator"]
        },
        "carrier": {
          enable: false,
          role: ["PORTAL_ADMIN"]
        },
        "user": {
          enable: false,
          role: ["PORTAL_ADMIN"]
        },
        "help": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) {
          this.navPermissions[item].enable = true;
          this.showNav=true;
        }
      });
    });
  },
}
</script>
